<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :edit-config="{ showStatus: true }"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{}" field="sourceType.name" title="business.label.sourcePosition">
        <vxe-input slot-scope="{row}" v-model="row.sourceType.name" align="center" placeholder="点击编辑" readonly type="text" @click="selectPositionType('sourcePositionTypeModal',row)"/>
      </vxe-column>
      <vxe-column :edit-render="{}" field="targetType.name" title="business.label.targetPosition">
        <vxe-input slot-scope="{row}" v-model="row.targetType.name" align="center" placeholder="点击编辑" readonly type="text" @click="selectPositionType('targetPositionTypeModal',row)"/>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
    <field-modal ref="sourcePositionTypeModal" :no="'POSITION_TYPE'" :show-value="false" :title="$t('business.label.sourcePosition')" @change="(rlt,row)=>row.sourceType=changePositionType(rlt[0])"/>
    <field-modal ref="targetPositionTypeModal" :no="'POSITION_TYPE'" :show-value="false" :title="$t('business.label.targetPosition')" @change="(rlt,row)=>row.targetType=changePositionType(rlt[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, saveAll } from '@/api/Api'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import { PackingPositionConfig } from '@/api/dto/config/PackingPositionConfig'
import { Dictionary } from '@/api/dto/admin/Dictionary'

export default {
  name: 'PackingPositionConfig',
  components: { FieldModal },
  data() {
    return {
      loading: false,
      data: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      contentSize: 0,
      page: 1,
      size: 20,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        'sourceType.name': [
          { required: true, type: 'string', message: '位置类型不能为空' }
        ],
        'targetType.name': [
          { required: true, type: 'string', message: '位置类型不能为空' }
        ]
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    selectPositionType(name, row) {
      this.$refs[name].open({ available: true }, row)
    },
    changePositionType(data) {
      return new Dictionary(data)
    },
    refresh() {
      this.loading = true
      this.data = []
      findAll('packingPositionConfigFactory', {}, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new PackingPositionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.data.push(new PackingPositionConfig())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords()
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('packingPositionConfigPersister', saveData).then(res => {
          if (res.success) {
            this.refresh()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>